import { createSlice } from '@reduxjs/toolkit';
import { ClaimDetailStateType } from 'src/types/claimDetail';

const initialState: ClaimDetailStateType = {
    data: null,
    changelog: null,
    loading: false,
    error: false,
};
export const claimDetailSlice = createSlice({
    name: 'claimDetail',
    initialState,
    reducers: {
        getClaimDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getClaimDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.changelog = null;
            state.loading = false;
        },
        getClaimDetailFetchFailure: (state, action) => {
            state.data = null;
            state.changelog = null;
            state.loading = false;
            state.error = true;
        },
        getClaimDetailChangelogFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getClaimDetailChangelogFetchSuccess: (state, action) => {
            state.changelog = action.payload.data;
            state.loading = false;
        },
        getClaimDetailChangelogFetchFailure: (state, action) => {
            state.changelog = null;
            state.loading = false;
            state.error = true;
        },
        createClaimDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createClaimDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.changelog = null;
        },
        createClaimDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
            state.changelog = null;
        },
        updateClaimDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateClaimDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.changelog = null;
        },
        updateClaimDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
            state.changelog = null;
        },
        patchClaimDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        patchClaimDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.changelog = null;
        },
        patchClaimDetailFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
            state.changelog = null;
        },
        editClaimDetailEshopNoteFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        editClaimDetailEshopNoteFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.changelog = null;
        },
        editClaimDetailEshopNoteFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
            state.changelog = null;
        },
        clearClaimDetail: () => initialState,
    },
});

export const {
    getClaimDetailFetch,
    getClaimDetailFetchSuccess,
    getClaimDetailFetchFailure,
    getClaimDetailChangelogFetch,
    getClaimDetailChangelogFetchSuccess,
    getClaimDetailChangelogFetchFailure,
    createClaimDetailFetch,
    createClaimDetailFetchSuccess,
    createClaimDetailFetchFailure,
    updateClaimDetailFetch,
    updateClaimDetailFetchSuccess,
    updateClaimDetailFetchFailure,
    patchClaimDetailFetch,
    patchClaimDetailFetchSuccess,
    patchClaimDetailFetchFailure,
    editClaimDetailEshopNoteFetch,
    editClaimDetailEshopNoteFetchSuccess,
    editClaimDetailEshopNoteFetchFailure,
    clearClaimDetail,
} = claimDetailSlice.actions;

export default claimDetailSlice.reducer;
